import { ShieldCheck, Zap, Snowflake, ScanFace } from "lucide-react";
import { IMAGES } from "../../lib/api";
import { Reveal } from "../motion";
import { useLang } from "../../lib/i18n";

const ICONS = [Zap, Snowflake, ScanFace, ShieldCheck];

export const Machine = () => {
  const { t } = useLang();
  const points = t("machine.points");

  return (
    <section id="machine" className="relative bg-espresso text-cream py-28 lg:py-36 grain-overlay overflow-hidden" data-testid="machine-section">
      <div className="absolute top-1/3 -left-40 w-[480px] h-[480px] rounded-full bg-taupe/20 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center relative">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-6 bg-gold/10 blur-2xl rounded-full pointer-events-none" />
              <img
                src={IMAGES.machine}
                alt="Machine Auraskin Gold"
                className="relative rounded-3xl w-full h-[420px] lg:h-[540px] object-cover spotlight-img"
                data-testid="machine-image"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <p className="text-[12px] tracking-[0.28em] uppercase text-gold mb-4">{t("machine.kicker")}</p>
            <h2 className="font-display tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-tight">
              {t("machine.titleA")} <span className="italic text-gold">{t("machine.titleB")}</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-cream/70 font-light leading-relaxed max-w-xl">
              {t("machine.sub")}
            </p>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-8">
            {points.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={p.title} delay={0.08 * i}>
                  <div className="flex gap-4 group" data-testid={`machine-point-${i}`}>
                    <Icon className="w-5 h-5 mt-1 text-gold shrink-0 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                    <div>
                      <h3 className="font-display text-xl">{p.title}</h3>
                      <p className="text-sm text-cream/60 font-light mt-1 leading-relaxed">{p.text}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
